/**
 * Cortex Nexus TypeScript Types
 */

// Agent types (existing)
export interface Agent {
  agent_id: string
  last_seen: string | null
  obs_count: number
  action_count: number
  success_rate: number | null
  pending_actions: number
}

// Observation types for Knowledge Constellation
export interface Observation {
  id: string
  agent: string
  obs_type: string
  content: string
  confidence: number
  source: string
  created_at: string
  expires_at: string | null
  embedding?: number[]
  metadata?: Record<string, unknown>
}

export interface ObservationsResponse {
  observations: Observation[]
  count: number
  generated_at: string
}

// Graph node for D3 visualization
export interface GraphNode {
  id: string
  observation: Observation
  x?: number
  y?: number
  vx?: number
  vy?: number
  fx?: number | null
  fy?: number | null
}

// Graph link for D3 visualization
export interface GraphLink {
  source: string | GraphNode
  target: string | GraphNode
  similarity: number
}

// Graph data structure
export interface GraphData {
  nodes: GraphNode[]
  links: GraphLink[]
}

// Agent color configuration
export interface AgentConfig {
  name: string
  color: string
  ringClass: string
}

export const AGENT_CONFIG: Record<string, AgentConfig> = {
  jc: {
    name: 'JC',
    color: '#06b6d4', // cyan-500
    ringClass: 'jc-ring'
  },
  hal: {
    name: 'Hal',
    color: '#f59e0b', // amber-500
    ringClass: 'hal-ring'
  },
  sterling: {
    name: 'Sterling',
    color: '#a855f7', // purple-500
    ringClass: 'sterling-ring'
  }
}
